var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBronzeStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94087 4.79619C3.94087 4.16891 4.46057 3.6604 5.10154 3.6604L12.2891 2.8125C12.2891 2.8125 13.7729 4.09922 13.9845 4.31778C14.1815 4.52133 14.3023 4.79619 14.3023 5.09867L13.5285 12.6706C13.5285 13.2979 13.0088 13.8064 12.3679 13.8064H4.63006C4.27481 13.8064 3.95678 13.6502 3.74389 13.4041C3.57266 13.2062 2.5 12.0039 2.5 12.0039L3.94087 4.79619Z",
    fill: "#B15A19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2345_108200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 13,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94087 4.79619C3.94087 4.16891 4.46057 3.6604 5.10154 3.6604L12.2891 2.8125C12.2891 2.8125 13.7729 4.09922 13.9845 4.31778C14.1815 4.52133 14.3023 4.79619 14.3023 5.09867L13.5285 12.6706C13.5285 13.2979 13.0088 13.8064 12.3679 13.8064H4.63006C4.27481 13.8064 3.95678 13.6502 3.74389 13.4041C3.57266 13.2062 2.5 12.0039 2.5 12.0039L3.94087 4.79619Z",
    fill: "#B15A19"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2345_108200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9149 3.92188L10.1136 4.28575L12.0753 7.84689L14.5501 11.1693L15.6049 9.0259L15.4545 8.76946L11.9149 3.92188ZM8.95661 7.03763L5.73047 8.15203L7.8435 12.1263L11.8561 16.5389L14.4283 13.3558L14.2605 13.0728L8.95661 7.03763Z",
    fill: "#853F0C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67677 3.8825C2.73809 3.10205 3.3893 2.5 4.17216 2.5H11.3772C12.2519 2.5 12.9411 3.24544 12.8726 4.11749L12.3226 11.1175C12.2613 11.898 11.6101 12.5 10.8272 12.5H3.62216C2.74742 12.5 2.05825 11.7546 2.12677 10.8825L2.67677 3.8825Z",
    fill: "#DD8047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39792 3.10938C3.77054 3.10938 3.24905 3.59264 3.20138 4.21821L2.73791 10.3012C2.7096 10.6728 2.8532 11.0154 3.09944 11.2542C3.05389 11.1265 3.03369 10.9872 3.0447 10.8426L3.53865 4.35967C3.57837 3.83837 4.01294 3.43564 4.53576 3.43564H10.9323C11.0532 3.43564 11.1687 3.457 11.2756 3.49604C11.0571 3.25898 10.7438 3.10938 10.3933 3.10938H4.39792Z",
    fill: "#B15A19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35561 6L7.1565 6.86241H9.34735L9.23418 8.15603H8.13875L9.54031 9.66524L11.2059 8.15603H10.1105L10.2991 6H6.35561ZM8.91746 9.66592L8.11657 8.80351H5.92571L6.03889 7.50989H7.13432L5.73276 6.00068L4.06712 7.50989H5.16255L4.97392 9.66592H8.91746Z",
    fill: "#A1400E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBronzeStatus);
export default __webpack_public_path__ + "static/media/ic_bronze-status.20ea2608c62fa0db24ba4175fc000ed9.svg";
export { ForwardRef as ReactComponent };